import React from 'react';
import { Grid, TextField } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { Controller } from 'react-hook-form';
import AccordionCard from '../../../Shared/Components/AccordionCard/AccordionCard';
import type { InvoiceCorrectionReasonSectionProps } from './InvoiceCorrectionReasonSection.types';

/**
 * InvoiceCorrectionReasonSection Component
 *
 * Displays a dedicated field for correction reason (Comments).
 * Used only for correction invoices (Type = Correction).
 *
 * Business Rules:
 * - Comments field is REQUIRED for correction invoices
 * - This text appears in PDF as "{{CorrectionReason}}" placeholder
 * - Fallback: "Korekta wartości faktury" if empty (backend)
 *
 * @example
 * <InvoiceCorrectionReasonSection control={control} errors={errors} />
 */
const InvoiceCorrectionReasonSection: React.FC<InvoiceCorrectionReasonSectionProps> = ({
  control,
  errors,
}) => {
  return (
    <AccordionCard
      title="Powód korekty"
      icon={<EditNoteIcon color="error" />}
      defaultExpanded={true}
    >
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }} >
          <Controller
            name="comments"
            control={control}
            render={({ field }) => (
              <TextField
                label="Powód korekty"
                placeholder="Np. Korekta ceny, zmiana ilości, błąd w danych kontrahenta..."
                value={field.value || ''}
                onChange={field.onChange}
                onBlur={field.onBlur}
                multiline
                rows={3}
                fullWidth
                required
                error={!!errors.comments}
                helperText={
                  errors.comments?.message ||
                  'Podaj przyczynę wystawienia faktury korygującej. To pole jest wymagane i pojawi się w PDF.'
                }
              />
            )}
          />
        </Grid>
      </Grid>
    </AccordionCard>
  );
};

export default InvoiceCorrectionReasonSection;
